/**
 * @generated SignedSource<<001023cde9de948d7864241ba9c6f701>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueStatus_nativeIssueTable_IssueStatusCell$data = {
  readonly status: {
    readonly name: string | null | undefined;
    readonly statusCategory: {
      readonly statusCategoryId: string;
    } | null | undefined;
    readonly statusId: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView">;
  readonly " $fragmentType": "issueStatus_nativeIssueTable_IssueStatusCell";
};
export type issueStatus_nativeIssueTable_IssueStatusCell$key = {
  readonly " $data"?: issueStatus_nativeIssueTable_IssueStatusCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueStatus_nativeIssueTable_IssueStatusCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueStatus_nativeIssueTable_IssueStatusCell",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        {
          "concreteType": "JiraStatusCategory",
          "kind": "LinkedField",
          "name": "statusCategory",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCategoryId"
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isInlineEditingEnabled",
              "variableName": "isInlineEditingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView"
        }
      ]
    }
  ],
  "type": "JiraStatusField"
};

(node as any).hash = "b561447fc88a5145b403ea27826107e7";

export default node;
